import { styled, Grid } from "@mui/material";

/***************************************
 * OVERALL
 ***************************************/
export const CarouselWrapper = styled(Grid)(({ theme }) => ({
  position: "sticky",
  top: 0,
  display: "flex",
  height: "100vh",
  padding: "40px",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  width: "100%",
  zIndex: 1,
}));

export const CarouselContentAndStepper = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "28px",
  alignSelf: "stretch",
  flex: "1 0 0",
});
export const CarouselContentAndStepperMobile = styled("div")({
  display: "flex",
  padding: "16px",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch",
});

/***************************************
 * STEPPER
 ***************************************/
export const CarouselStepper = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const CarouselStepperRectangle = styled("div")({
  display: "flex",
  width: "35px",
  height: "8px",
  justifyContent: "center",
  alignItems: "center",
  aspectRatio: "35/8",
  flexShrink: 0,
  borderRadius: "4px",
  background: "#FC4C4C",
});

export const CarouselStepperCircle = styled("div")({
  width: "8px",
  height: "8px",
  borderRadius: "100px",
  background: "#FCF6EB",
});

/***************************************
 * CONTENT
 ***************************************/
export const CarouselContent = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: "28px",
  flex: "1 0 0",
  alignSelf: "stretch",
});

export const CarouselHeader = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",
  animation: "fadeIn 1s ease-in-out",
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
});

export const CarouselHeaderText = styled("div")({
  color: "#FFF",
  fontFamily: "Roobert",
  fontSize: "39px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "47px",
  letterSpacing: "-0.78px",
});

export const CarouselHeaderSubtext = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
export const CarouselHeaderSubtextMobile = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
});

export const CarouselHeaderSubtextRedRectangle = styled("div")({
  width: "3px",
  background: "#FC4C4C",
  height: "16px",
});
export const CarouselHeaderSubtextRedRectangleMobile = styled("div")({
  width: "3px",
  background: "#FC4C4C",
  alignSelf: "stretch",
});

export const CarouselHeaderSubtextText = styled("div")({
  color: "#FFF",
  fontFamily: "Roobert",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "20px",
});

/***************************************
 * DYNAMIC BODY
 ***************************************/

// -----------------BROKER IMAGE-----------------
export const CarouselBrokerBodyMobile = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "32px",
  alignSelf: "stretch",
  flex: "1 0 0",
});

// In your styles file, update these components:
export const CarouselBrokerImage = styled("div")<{ backgroundImage: string }>(
  ({ backgroundImage }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    flex: "1 0 0",
    alignSelf: "stretch",
    borderRadius: "12px",
    background: `url(${backgroundImage}) 50% / contain no-repeat`,
    backgroundColor: "#002035",
    animation: "fadeIn 1s ease-in-out",
    "@keyframes fadeIn": {
      "0%": {
        opacity: 0,
      },
      "100%": {
        opacity: 1,
      },
    },
  }),
);

export const CarouselBrokerImageMobile = styled("img")(() => ({
  width: "100%",
  height: "auto",
  borderRadius: "12px",
  animation: "fadeIn 1s ease-in-out",
}));
